module.exports = __webpack_public_path__ + "static/uni_kapor-41a0d30cd28e4f07a20b8d62bc9c09a2.png";